import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';

const ErrorFocus = ({ ageValidationError }) => {
    const { isSubmitting, isValidating, errors } = useFormikContext();

    useEffect(() => {
        const keys = Object.keys(errors);
        let selector;
        let errorElement;

        if (ageValidationError && isSubmitting && !isValidating) {
            // Use a custom selector for the age validation error
            selector = '.age-validation-error';
            errorElement = document.querySelector(selector);
        } else if (keys.length > 0 && isSubmitting && !isValidating) {
            // Use the existing logic for other errors
            selector = `[name="${keys[0]}"]:not([type="hidden"]), [id="${keys[0]}"]:not([type="hidden"])`;
            errorElement = document.querySelector(selector);
        } else {
            errorElement = null;
        }

        if (errorElement) {
            if (errorElement.tagName.toLowerCase() === 'div' || errorElement.tagName.toLowerCase() === 'p') {
                errorElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
                errorElement.focus();
            }
        }
    }, [ageValidationError, errors, isSubmitting, isValidating]);

    // Returning null because this component doesn't render anything
    return null;
};

export default ErrorFocus;
